/** Router state the record page sends when it opens the category master, so that page can offer the way back. */
export const FROM_RECORD_EXPENSE = { returnTo: 'record-expense' } as const;

/** Whether the category master was opened from the record page; anything else in the history entry counts as no. */
export function cameFromRecordExpense(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { returnTo?: unknown }).returnTo === FROM_RECORD_EXPENSE.returnTo
  );
}
